<footer class="bg-safety-yellow">
  <div class="flex justify-between mx-8 items-center pt-3 pb-3"
  >
    <label class="text-xs text-arsenic"> {{ footerLabel }} </label>
    <div [class.mobile-footer]="isMobile">
      @if (linkFooter) {
      <a
        (click)="footerLink(linkFooter.url)"
        class="cursor-pointer text-xs text-arsenic"
        [title]="linkFooter.label"
      >
        {{ linkFooter.label }}
      </a>
      }
    </div>
  </div>
</footer>
